export default __webpack_public_path__ + "static/media/1 BHK B 3D - 909.85.7929f12a.png";